export default '/Volumes/Development_Lacie/Development/new/jeep-sqlite/node_modules/sql.js/dist'